import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getOutbound = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Outbound/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createOutbound = (payload) => {
  return axios.post(`${URL_ORI}/api/Outbound`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdOutbound = (id) => {
  return axios
    .get(`${URL_ORI}/api/Outbound/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateOutbound = (payload) => {
  return axios.put(`${URL_ORI}/api/Outbound`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateOutboundStartWorkFlow = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Outbound/StartWorkFlow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateOutboundSetStatus = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Outbound/setstatus`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateOutboundCancel = (payload) => {
  return axios.put(`${URL_ORI}/api/Outbound/Cancel`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateOutboundConfirm = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Outbound/Confirm`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateOutboundAmend = (payload) => {
  return axios.put(`${URL_ORI}/api/Outbound/Amend`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateOutboundAmmend = (payload) => {
  return axios.put(`${URL_ORI}/api/Outbound/ammend`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteOutbound = (payload) => {
  return axios.delete(`${URL_ORI}/api/Outbound`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createOutboundVehicles = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Outbound/addVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteOutboundVehicles = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Outbound/deleteVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createOutboundParties = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Outbound/addParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const uploadOutbound = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Outbound/UploadOutboundVehicle?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadPicking = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Outbound/UploadPickingOutbound?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadBTS = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Outbound/UploadBackToStorageOutbound?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Vehicle

export const getVehicle = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Outbound/searchvehicleInOutbound`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createVehicle = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Outbound/AddVehicle`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateVehicle = (payload) => {
  return axios.put(`${URL_ORI}/api/Outbound/UpdateVehicleOutbound`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const deleteVehicle = (payload) => {
  return axios.delete(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// party
export const getparty = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Outbound/searchpartyInOutbound`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createParty = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Outbound/AddParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateParty = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Outbound/UpdateParty`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteParty = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Outbound/deleteParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Transportations
export const getTransportations = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Outbound/SearchTransportinOutbound`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createTransportations = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Outbound/AddTransportation`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateTransportations = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Outbound/UpdateTransportation`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteTransportations = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Outbound/deleteTransportation`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Generate Excel
export const getGenerateExcelBlob = (payload) => {
  return axios
    .post(
      `${URL_ORI}/api/RDM/GenerateExcel`,
      payload,
      {
        responseType: 'blob',
      }
    )
    .catch((error) => {
      if (error.response) {
        console.log(error.response, "eerorr");

        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
